import { useState, useEffect } from "react";

import axios from "axios";
import Loader from "../../UI/Loader/Loader";
import { useTheme } from "@mui/material/styles";
import { useFilters } from "../../../Context/FiltersContext";
import { MenuProps, getStyles, Headers, useStyles } from "../Utils";
import { Select, MenuItem, FormControl, FormHelperText } from "@mui/material";
import { INVOKE_URL } from "../../../constants/api";

const Projects = () => {
  const theme = useTheme();
  const { projectKey, setProjectKey } = useFilters();

  const [projectsData, setProjectsData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const projectKeySS = JSON.parse(sessionStorage.getItem("projectKey")) || [];

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchProjects(signal);

    return () => controller.abort();
  }, []);

  const fetchProjects = async (signal) => {
    try {
      // const response = await axios.get('/projects', {signal}); // Dev only test
      const response = await axios.get(`${INVOKE_URL}/projects`, { Headers, signal });
      setProjectsData(response.data);
      setLoader(false);
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  /**
   * BAs and PMs may request a specific order for the projects.
   * The predefinedOrder array is utilized to reverse the project names' order,
   * and the last two indexes of the array are then swapped.
   * The desired order for the projects is as follows: ["Sound+ Playout", "Spartans", "Sound+ Athens Projects", "SIA"]
   * For any new project added to the list, please consult with BAs or PMs
   * to confirm if the order needs adjustment or to determine the desired display order on the UI.
   */
  const predefinedOrder = [...projectsData].reverse();
  if (predefinedOrder.length >= 2) {
    const lastIndex = predefinedOrder.length - 1;
    [predefinedOrder[lastIndex - 1], predefinedOrder[lastIndex]] = [predefinedOrder[lastIndex], predefinedOrder[lastIndex - 1]];
  }

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
      <Select
        label="Projects"
        id="projects"
        multiple={true}
        value={projectKeySS ?? []}
        MenuProps={MenuProps}
        onChange={(e) => {
          setProjectKey(e.target.value);
          localStorage.setItem("projectKey", e.target.value); // Storing value so it can be displayed in the Preview page.
          sessionStorage.setItem("projectKey", JSON.stringify(e.target.value));
          setIsOpen(false);
        }}
        renderValue={(selected) => selected.join(", ")}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      >
        {!loader ? (
          predefinedOrder.map(({ key, name }) => (
            <MenuItem key={key} value={key} style={getStyles(name, projectKey, theme)}>
              {name}
            </MenuItem>
          ))
        ) : (
          <Loader />
        )}
      </Select>
      <FormHelperText style={useStyles.formHelperText}>Choose one or multiple projects.</FormHelperText>
    </FormControl>
  );
};

export default Projects;
